module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/42115eaf3865efbbda1feaffc63c9a33.png";